import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/*
 * Created on Thu Oct 17 2019
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { GenericTransportLayer } from '../GenericTransportLayer';
import { jsonConversions, Overview, Pagination, SuppliedProductConverter, SuppliedProductOverviewFilterConverter, ResultWithOverviewConverterImpl } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
/**
 * @author Tomáš Leity
 */

export var SuppliedProductLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(SuppliedProductLayer, _GenericTransportLaye);

  function SuppliedProductLayer() {
    var _this;

    _classCallCheck(this, SuppliedProductLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SuppliedProductLayer).call(this, CONSTANTS.API.ENDPOINTS.PRODUCTS_SUPPLIED));

    _this.filter = function (overview) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var overviewResultConverter;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                overviewResultConverter = new ResultWithOverviewConverterImpl(this.getConverter(), this.overviewFilterConverter);
                return _context.abrupt("return", api(CONSTANTS.API.ENDPOINTS.PRODUCTS_SUPPLIED).post({
                  overview: overview
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return overviewResultConverter.toObject(response.data, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    return _this;
  }

  _createClass(SuppliedProductLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Gets SuppliedProduct DTO based on overview filter.
     * @param filter
     * @param pageNum
     * @param pageLimit
     * @param sorting
     * @param projection
     */

  }, {
    key: "findSuppliedProducts",
    value: function findSuppliedProducts(filter) {
      var pageNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var pageLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
      var sorting = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var projection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var pagination = new Pagination(pageLimit, pageLimit * (pageNum - 1), null);
      var overview = new Overview(filter, sorting, projection, pagination);
      var overviewResultConverter = new ResultWithOverviewConverterImpl(this.getConverter(), this.overviewFilterConverter);
      return api(CONSTANTS.API.ENDPOINTS.PRODUCTS_SUPPLIED).post({
        overview: overview
      }, {
        responseType: 'json'
      }).then(function (response) {
        return overviewResultConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return SuppliedProductLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", SuppliedProductConverter)], SuppliedProductLayer.prototype, "converter", void 0);

__decorate([Inject, __metadata("design:type", SuppliedProductOverviewFilterConverter)], SuppliedProductLayer.prototype, "overviewFilterConverter", void 0);